import { useState, useEffect } from "react";
import { publicGet } from "../club-site/publicApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FC = "lefteria_fc";
const cachedSeasons = new Map();
const pendingSeasons = new Map();

// Each club has its own current season. Never reuse an Academy result for FC.
export async function getCurrentSeasonName(organizationId = FC) {
  if (cachedSeasons.has(organizationId)) return cachedSeasons.get(organizationId);
  if (!pendingSeasons.has(organizationId)) {
    pendingSeasons.set(organizationId, publicGet(`${API}/current-season?organization_id=${encodeURIComponent(organizationId)}`)
      .then(response => {
        const name = response.data?.name || "";
        if (name) cachedSeasons.set(organizationId, name);
        return name;
      })
      .catch(() => "")
      .finally(() => pendingSeasons.delete(organizationId)));
  }
  return pendingSeasons.get(organizationId);
}

export function useCurrentSeason(organizationId = FC) {
  const [season, setSeason] = useState(cachedSeasons.get(organizationId) || "");
  useEffect(() => {
    let mounted = true;
    setSeason(cachedSeasons.get(organizationId) || "");
    getCurrentSeasonName(organizationId).then(name => { if (mounted) setSeason(name); });
    return () => { mounted = false; };
  }, [organizationId]);
  return season;
}

export function clearCurrentSeasonCache() {
  cachedSeasons.clear();
  pendingSeasons.clear();
}
